import { useDispatch, useSelector } from 'react-redux';
import { updateUserLoanDetails } from 'redux-implementations/loanDetails';
import { AppDispatch } from 'redux-implementations/makeStore';
import { LoanDetails } from 'types/LoanDetails';
import State from 'types/State';

export function useUserLoanDetails(): {
  userLoanDetailsState: LoanDetails;
  saveUserLoanDetails: (loanDetailsValues: LoanDetails) => void;
} {
  const dispatch = useDispatch<AppDispatch>();
  const userLoanDetailsState = useSelector<State, LoanDetails>((state) => state?.loanDetails);

  const saveUserLoanDetails = (loanDetailsValues: LoanDetails): void => {
    dispatch(updateUserLoanDetails({ ...loanDetailsValues }));
  };

  return { userLoanDetailsState, saveUserLoanDetails };
}
